module.exports = __webpack_public_path__ + "media/images/mobile/city_img/e-dd01bdb18cb9f9ed12cef185ad188a16.jpg";